import { IPreviewJourney, } from 'atlas-shared';
import { IJourneyStore, JourneyActions, TJourneyActionTypes, } from '@Store';

export const JourneyReducer = (state: IJourneyStore = {
  loaded: false,
  loading: false,
  journeies: [],
  dict: {},
}, action: TJourneyActionTypes): IJourneyStore => {
  switch (action.type) {
  case JourneyActions.LOADING:
    return { ...state, loading: true, };
  case JourneyActions.SET_STATE:
    const dict: IJourneyStore['dict'] = {};

    action.payload.forEach((journey: IPreviewJourney) => dict[journey.id] = journey);

    return { ...state, loaded: true, loading: false, journeies: action.payload, dict, };
  case JourneyActions.ADD_STATE:
    return { ...state, journeies: [...state.journeies, action.payload, ], dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  case JourneyActions.REMOVE_STATE: {

    const { [action.payload]: _deleted, ...dict } = state.dict;

    return { ...state, journeies: state.journeies.filter((item: IPreviewJourney) => item.id !== action.payload), dict, };
  }
  case JourneyActions.UPDATE_STATE:
    const journeies = [...state.journeies, ];
    const index = state.journeies.findIndex((journey: IPreviewJourney) => journey.id === action.payload.id);

    if (!~index)
      journeies.push(action.payload);
    else
      journeies[index] = action.payload;

    return { ...state, journeies, dict: { ...state.dict, [action.payload.id]: action.payload, }, };
  default:
    return state;
  }
};
